// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Card$Showside from "./Card.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as SmartImg$Showside from "../utils/SmartImg.bs.js";
import * as BasicTypes$Showside from "../types/BasicTypes.bs.js";
import * as IframeEmbed$Showside from "../utils/IframeEmbed.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as GalleryButton$Showside from "./GalleryButton.bs.js";
import * as SmartNavVideo$Showside from "./SmartNavVideo.bs.js";
import * as UseWindowSize$Showside from "../hook/UseWindowSize.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as DesktopPhotoZoom$Showside from "./DesktopPhotoZoom.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as ProductCardCTAButton$Showside from "./ProductCardCTAButton.bs.js";
function getMediaSize(item) {
  var tmp;
  switch (item.TAG | 0) {
    case /* Image */0:
      var match = item._0;
      tmp = [match.width, match.height];
      break;
    case /* Video */1:
      tmp = Belt_Option.map(Product$Showside.getVideoSource(item._0), function (source) {
        return [source.width, source.height];
      });
      break;
    case /* IframeEmbed */2:
      tmp = undefined;
      break;
  }
  return Belt_Option.map(tmp, function (param) {
    return [Math.max(param[0], 1), Math.max(param[1], 1)];
  });
}
function DesktopPhotoGrid(Props) {
  var product = Props.product;
  var variantId = Props.variantId;
  var productCategory = Props.productCategory;
  var medias = Props.medias;
  var viewport = Props.viewport;
  var settings = Props.settings;
  var containerWidthAdjustmentOpt = Props.containerWidthAdjustment;
  var maxContainerHeightOpt = Props.maxContainerHeight;
  var maxCountOpt = Props.maxCount;
  var containerWidthAdjustment = containerWidthAdjustmentOpt !== undefined ? containerWidthAdjustmentOpt : 0;
  var maxContainerHeight = maxContainerHeightOpt !== undefined ? maxContainerHeightOpt : 1000;
  var maxCount = maxCountOpt !== undefined ? maxCountOpt : 4;
  var match = EntrypointContext$Showside.use(undefined);
  var trackEvent = match.trackEvent;
  var match$1 = RouterProvider$Showside.useRouter(undefined);
  var goTo = match$1.goTo;
  var route = match$1.route;
  var shape = settings.productCardShape;
  var ratio = Card$Showside.Size.getRatio(shape);
  var shapeWithoutCustom = typeof shape === "number" ? shape : BasicTypes$Showside.CardShape.getClosestCardShapeByAspectRatio(shape._0, shape._1);
  var count = Math.min(medias.length, maxCount);
  var isAsymmetric;
  if (typeof shapeWithoutCustom === "number") {
    switch (shapeWithoutCustom) {
      case /* Landscape */2:
      case /* Panorama */4:
      case /* Wide */5:
        isAsymmetric = count === 3;
        break;
      case /* Circle */0:
      case /* Square */1:
      case /* Portrait */3:
      case /* Tall */6:
        isAsymmetric = count === maxCount;
        break;
    }
  } else {
    isAsymmetric = false;
  }
  var match$2 = isAsymmetric ? count !== 3 ? [5, 2] : [3, 2] : count !== 4 ? [count | 0, 1] : [2, 2];
  var cols = match$2[0];
  var gapCount = cols - 1 | 0;
  var gapWidth = 12 * gapCount;
  var containerWidth = UseWindowSize$Showside.useWindowWidth(undefined, undefined, undefined, undefined) + containerWidthAdjustment | 0;
  var itemWidth = (containerWidth - gapWidth) / cols;
  var itemWidth$1 = isAsymmetric ? itemWidth * 2 : itemWidth;
  var containerHeight = itemWidth$1 / ratio | 0;
  var containerHeight$1 = Math.min(containerHeight, maxContainerHeight);
  var itemWidth$2 = containerHeight$1 * ratio;
  var itemWidth$3 = isAsymmetric ? itemWidth$2 / 2 : itemWidth$2;
  var containerWidth$1 = itemWidth$3 * cols + gapWidth;
  var rowHeight = isAsymmetric ? containerHeight$1 / 2 : containerHeight$1;
  var getArea = function (index) {
    var match = (count | 0) - index | 0;
    var match$1 = isAsymmetric && !(match === 2 || match === 1) ? [2, 2] : [1, 1];
    var rowSpan = match$1[1];
    var colSpan = match$1[0];
    return "span " + String(colSpan) + " / span " + String(colSpan) + "" + (" / span " + String(rowSpan) + " / span " + String(rowSpan) + "");
  };
  var onPhotoZoomed = React.useCallback(function (index) {
    if (typeof route !== "number") {
      switch (route.TAG | 0) {
        case /* PDP */2:
          var payload = route._0;
          return Curry._3(goTo, undefined, true, {
            TAG: /* PDP */2,
            _0: {
              categoryId: payload.categoryId,
              productCategoryId: payload.productCategoryId,
              productId: payload.productId,
              variantId: payload.variantId,
              zoomedPhotoIndex: index
            }
          });
        case /* QuickView */3:
          var payload$1 = route._0;
          return Curry._3(goTo, undefined, undefined, {
            TAG: /* QuickView */3,
            _0: {
              mediaId: payload$1.mediaId,
              mediaParentId: payload$1.mediaParentId,
              albumId: payload$1.albumId,
              productId: payload$1.productId,
              relatedMediaProductIds: payload$1.relatedMediaProductIds,
              relatedMediaCategoryId: payload$1.relatedMediaCategoryId,
              variantId: payload$1.variantId,
              panelClosed: payload$1.panelClosed,
              zoomedPhotoIndex: index,
              time: payload$1.time
            }
          });
        default:
      }
    }
    Curry._3(goTo, undefined, true, {
      TAG: /* PDP */2,
      _0: {
        categoryId: productCategory.id,
        productCategoryId: productCategory.id,
        productId: product.id,
        variantId: variantId,
        zoomedPhotoIndex: index
      }
    });
  }, [RouterProvider$Showside.toString(route)]);
  var onSlideChange = function (param) {
    Curry.app(trackEvent, ["product details:image scroll", undefined, undefined, product, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
  };
  var onClickThumbnail = function (param) {
    Curry.app(trackEvent, ["product details:image select", undefined, undefined, product, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
  };
  var tmp;
  if (typeof route === "number" || route.TAG !== /* PDP */2) {
    tmp = null;
  } else {
    var zoomedPhotoIndex = route._0.zoomedPhotoIndex;
    if (Belt_Option.isSome(zoomedPhotoIndex)) {
      var tmp$1 = {
        product: product,
        variantId: variantId,
        medias: medias,
        viewport: viewport,
        onSlideChange: onSlideChange,
        onClickThumbnail: onClickThumbnail,
        bgBlur: false,
        thumbnailsPosition: "center",
        onClose: function (param) {
          Curry._1(onPhotoZoomed, undefined);
        },
        onPhotoZoomed: onPhotoZoomed
      };
      if (zoomedPhotoIndex !== undefined) {
        tmp$1.selectedIndex = Caml_option.valFromOption(zoomedPhotoIndex);
      }
      tmp = React.createElement(DesktopPhotoZoom$Showside.make, tmp$1);
    } else {
      tmp = null;
    }
  }
  return React.createElement(React.Fragment, undefined, React.createElement(DataAttribute$Showside.make, {
    dataTestId: "pdp-images",
    children: React.createElement("div", {
      className: CSS$Showside.prefix("w-full flex justify-center mb-14")
    }, React.createElement("div", {
      className: CSS$Showside.prefix("grid grid-flow-col gap-4"),
      style: {
        width: String(containerWidth$1) + "px",
        gridTemplateColumns: "repeat(" + String(cols) + ", minmax(0, 1fr))",
        gridTemplateRows: "repeat(" + String(match$2[1]) + ", minmax(0, " + String(rowHeight) + "px))"
      }
    }, Belt_Array.mapWithIndex(Belt_Array.slice(medias, 0, count | 0), function (idx, item) {
      var tmp;
      switch (item.TAG | 0) {
        case /* Video */1:
          tmp = Belt_Option.getWithDefault(Belt_Option.map(Product$Showside.getVideoSource(item._0), function (source) {
            return source.url;
          }), String(idx));
          break;
        case /* Image */0:
        case /* IframeEmbed */2:
          tmp = item._0.url;
          break;
      }
      var tmp$1;
      switch (item.TAG | 0) {
        case /* Image */0:
          tmp$1 = React.createElement(SmartImg$Showside.make, {
            src: item._0.url,
            fit: settings.productCardFitToContainer ? /* Contain */2 : /* Cover */1,
            alt: product.name,
            priority: 0
          });
          break;
        case /* Video */1:
          var video = item._0;
          var src = Belt_Option.map(Product$Showside.getVideoSource(video), function (source) {
            return source.url;
          });
          if (src !== undefined) {
            var tmp$2 = {
              src: src,
              viewport: viewport,
              objectFit: settings.productCardFitToContainer ? "contain" : "cover",
              prioritize: true,
              autoplay: settings.videoAutoPlay,
              loop: settings.videoLoop,
              muted: settings.videoMute,
              controls: settings.videoControls,
              key: variantId
            };
            if (video.posterUrl !== undefined) {
              tmp$2.poster = video.posterUrl;
            }
            tmp$1 = React.createElement(SmartNavVideo$Showside.make, tmp$2);
          } else {
            tmp$1 = null;
          }
          break;
        case /* IframeEmbed */2:
          tmp$1 = React.createElement(IframeEmbed$Showside.make, {
            url: item._0.url
          });
          break;
      }
      return React.createElement("div", {
        key: tmp,
        "aria-label": "Zoom in on product photo",
        className: CSS$Showside.prefix("relative col-start-auto	row-start-auto cursor-zoom-in shadow-lg"),
        role: "button",
        style: {
          backgroundColor: "var(--smartnav-color-placeholder, rgb(229, 231, 235))",
          gridArea: getArea(idx)
        },
        tabIndex: 0,
        onClick: function (param) {
          Curry._1(onPhotoZoomed, idx);
        }
      }, tmp$1, idx === ((count | 0) - 1 | 0) ? React.createElement("div", {
        className: CSS$Showside.prefix("absolute bottom-8 right-8 flex gap-4")
      }, React.createElement(GalleryButton$Showside.make, {
        product: product,
        variantId: variantId
      }), medias.length > (count | 0) ? React.createElement(ProductCardCTAButton$Showside.make, {
        size: /* Md */2,
        label: "See More Photos",
        onClick: function (param) {
          Curry._1(onPhotoZoomed, 0);
        },
        primary: true,
        preventDefault: true
      }) : null) : null);
    })))
  }), tmp);
}
DesktopPhotoGrid.displayName = "DesktopPhotoGrid";
var gap = 12;
var make = DesktopPhotoGrid;
export { gap, getMediaSize, make };
/* react Not a pure module */